import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-l",
  "use": "arrow-l-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-l\"><defs><style>#arrow-l .cls-1{fill:none}</style></defs><title>资源 83</title><g id=\"arrow-l_图层_2\" data-name=\"图层 2\"><g id=\"arrow-l_图层_1-2\" data-name=\"图层 1\"><path id=\"arrow-l_Rectangle_36_Copy_9\" data-name=\"Rectangle 36 Copy 9\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"arrow-l_left\"><path id=\"arrow-l_Shape\" d=\"M17 21a1.08 1.08 0 0 1-.65-.22l-9.93-8a1 1 0 0 1-.16-1.44l.16-.16 9.89-7.95a1 1 0 1 1 1.28 1.6L8.66 12l8.94 7.19A1 1 0 0 1 17 21z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-l.svg
// module id = HOFY
// module chunks = 6